import { ReactElement } from "react";
import { OverlayArrow, Tooltip, TooltipTrigger } from "react-aria-components";

import TooltipButtonWrapper from "./components/TooltipButtonWrapper";

import "./styles.scss";

export interface Props {
  children: ReactElement;
  tooltip: string;
}

export default function TooltipContainer(props: Props) {
  return (
    <TooltipTrigger>
      <TooltipButtonWrapper>{props.children}</TooltipButtonWrapper>
      <Tooltip>
        <OverlayArrow>
          <svg width={8} height={8} viewBox="0 0 8 8">
            <path d="M0 0 L4 4 L8 0" />
          </svg>
        </OverlayArrow>
        {props.tooltip}
      </Tooltip>
    </TooltipTrigger>
  );
}
